<div class="progress-monitor-container">
  <mat-card class="progress-card">
    <mat-card-content>
      <!-- Header -->
      <div class="progress-header">
        <div class="header-content">
          <mat-icon class="progress-icon" [class.spinning]="status.status === 'processing'">
            {{ getStatusIcon(status.status) }}
          </mat-icon>
          <div class="header-text">
            <h3 class="process-name">{{ status.name }}</h3>
            <p class="status-message">{{ status.message }}</p>
          </div>
        </div>
        @if (status.status !== 'processing') {
          <button mat-icon-button (click)="onClose.emit()" class="close-button">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      <!-- Progress Bar -->
      <div class="progress-section">
        <div class="progress-info">
          <span class="progress-label">{{ getStatusLabel(status.status) }}</span>
          <span class="progress-percentage">{{ status.progress_percentage }}%</span>
        </div>
        <mat-progress-bar
          mode="determinate"
          [value]="status.progress_percentage"
          [color]="getProgressColor(status.status)">
        </mat-progress-bar>
      </div>

      <!-- Stats -->
      <div class="stats-section">
        <div class="stat-item">
          <mat-icon class="stat-icon">target</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Target</span>
            <span class="stat-value">{{ status.target_statements }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon">check_circle</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Generated</span>
            <span class="stat-value">{{ status.generated_statements_count }}</span>
          </div>
        </div>
        <div class="stat-item">
          <mat-icon class="stat-icon">schedule</mat-icon>
          <div class="stat-content">
            <span class="stat-label">Status</span>
            <span class="stat-value status-badge" [ngClass]="'status-' + status.status">
              {{ status.status }}
            </span>
          </div>
        </div>
      </div>

      <!-- Async pipeline execution reference — visible while running so the
           user can quote it when reporting issues. -->
      @if (status.execution_uuid && status.status === 'processing') {
        <div class="execution-ref">
          <mat-icon class="execution-icon">tag</mat-icon>
          <span class="execution-label">Execution ID:</span>
          <code class="execution-uuid">{{ status.execution_uuid }}</code>
        </div>
      }

      <!-- User-friendly failure notice (always shown on failed status) -->
      @if (status.status === 'failed') {
        <div class="failure-notice">
          <mat-icon class="failure-icon">report_problem</mat-icon>
          <div class="failure-text">
            <p class="failure-headline">Please check input data and retry</p>
            @if (status.error_message) {
              <p class="failure-detail">{{ status.error_message }}</p>
            }
          </div>
        </div>
      }

      <!-- Technical error (shown only when not failed but error_message exists, e.g. partial errors) -->
      @if (status.status !== 'failed' && status.error_message) {
        <div class="error-section">
          <mat-icon class="error-icon">error</mat-icon>
          <p class="error-message">{{ status.error_message }}</p>
        </div>
      }

      <!-- Action Buttons -->
      <div class="action-section">
        @if (status.status === 'completed') {
          <button mat-raised-button color="primary" (click)="onViewStatements.emit()" class="view-button">
            <mat-icon>visibility</mat-icon>
            View {{ status.generated_statements_count }} Statements
          </button>
        }
        @if (status.status === 'failed') {
          <button mat-raised-button color="warn" (click)="onRetry.emit()" class="retry-button">
            <mat-icon>refresh</mat-icon>
            Retry
          </button>
        }
        <!-- Always available: show the data sent for this generation and load it
             back into the input form so the user can review / re-run it. -->
        <button mat-stroked-button color="primary" (click)="onLoadInputData.emit()" class="load-input-button">
          <mat-icon>edit_note</mat-icon>
          {{ 'components.statement-generator.progress.load-input-data' | translate }}
        </button>
      </div>

      <!-- Applied Toggles -->
      @if (status.applied_toggles) {
        <div class="toggles-section">
          <p class="toggles-title">Applied Settings:</p>
          <div class="toggles-list">
            @if (status.applied_toggles.strict_evidence_mode) {
              <span class="toggle-chip">
                <mat-icon>verified</mat-icon>
                Strict Evidence Mode
              </span>
            }
            @if (status.applied_toggles.minimize_off_label_tone) {
              <span class="toggle-chip">
                <mat-icon>policy</mat-icon>
                Minimize Off-Label Tone
              </span>
            }
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
